import { Box, Tooltip } from '@mui/material';
import { FC, ReactElement } from 'react';

interface CustomActionTooltipProps {
	tooltipMessage: string;
	children: ReactElement;
	check: boolean;
	position?:
		| 'right'
		| 'bottom'
		| 'left'
		| 'top'
		| 'bottom-end'
		| 'bottom-start'
		| 'left-end'
		| 'left-start'
		| 'right-end'
		| 'right-start'
		| 'top-end'
		| 'top-start'
		| undefined;
	styles?: Record<string, string | number>;
}

export const CustomActionTooltip: FC<CustomActionTooltipProps> = ({
	tooltipMessage,
	children,
	check,
	position = 'bottom',
	styles,
}) => {
	if (check) {
		return (
			<Tooltip
				componentsProps={{
					tooltip: {
						sx: {
							backgroundColor: '#f5f5f9',
							color: 'rgba(0, 0, 0, 0.87)',
							fontSize: '12px',
							maxWidth: 200,
							textAlign: 'center',
							marginBottom: '5px',
							border: '1px solid #dadde9',
							'& .MuiTooltip-popper': { margin: 0 },
							...styles,
						},
					},
					popper: {
						sx: {
							marginBottom: '5px',
						},
					},
				}}
				PopperProps={{
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [0, 0],
							},
						},
					],
				}}
				title={tooltipMessage}
				placement={position}
			>
				<Box>{children}</Box>
			</Tooltip>
		);
	}
	return children;
};
